<template>
    <div id="cloud">
        <div id="cloudNav" class="cle">
            <div id="cloudManage" class="fl" :title="deviceManagerText" v-text="deviceManagerText"></div>
            <button id="cloudAdd" class="fl" type="button" @click="bombShows" :title="addDeviceText" v-text="addDeviceText"></button>
            <button id="addAll" v-show="isHSLogin" class="fl" type="button" @click="hsLoginShow" :title="addAll" v-text="addAll"></button>
            <button id="refresh" class="fl" type="button" @click="refreshSet" :title="refresh" v-text="refresh"></button>
            <div id="userLogout" class="fr cle">
                <div id="ulUser" class="fl cle">
                    <img :src="userImg" class="fl" alt="">
                    <span v-text="userName" :title="userName" class="fl" @click="bombShow"></span>
                </div>
                <div id="ulLogout" class="fl cle">
                    <img :src="logoutImg" class="fl" alt="">
                    <span @click="logout" :title="logoutText" class="fl" v-text="logoutText"></span>
                </div>
            </div>
        </div>
        <div id="cloudContent">
            <div class="downVp" v-if="vPIn">
                <span v-text="vpText"></span>
                <a :href="vpDownUrl" v-text="vpTextUrl"></a>
            </div>
            <MyDevice class="listTop" ref="deviceL" :ocx="ocx" :myDevice="myDevice" v-on:shareBom="shareBoms" v-on:editBom="editBoms" v-on:loadMsg="loadMsg" v-on:reRemind="receiveOnceSet" v-on:remindSH="remindSHSet" v-on:remindGet="remindGet" v-on:refresh="refreshSet"></MyDevice>
            <ShareDevice class="listTop" :ocx="ocx" :shareDevice="shareDevice" v-on:editBom="editBoms" v-on:loadMsg="loadMsg" v-on:refresh="refreshSet"></ShareDevice>
            <ShareRecords v-if="false" class="listTop" :language="language"></ShareRecords>
        </div>
        <UserMes v-show="bomb" ref="userL" v-on:msgHide="bombHide" :language="language" :userName="userName" v-on:refresh="refreshSet"></UserMes>
        <AddDevice v-show="bombs" ref="addL" v-on:msgHides="bombHides" :language="language" v-on:list="addGetList" v-on:refresh="refreshSet"></AddDevice>
        <AddDeviceHs v-show="hsLogin" ref="addI" :ocx="ocx" v-on:hide="hsLoginHide" v-on:loadMsg="loadMsg" v-on:list="addIm" v-on:refresh="refreshSet"></AddDeviceHs>
        <ShareToFriend v-show="sharebom" ref="share" v-on:close="shareClose" :language="language" v-on:refresh="refreshSet"></ShareToFriend>
        <shareToFriends v-show="shareSet" ref="shareSet" v-on:close="shareClosed" v-on:power="sharePower" v-on:loadMsg="loadMsg" v-on:refresh="refreshSet"></ShareToFriends>
        <EditDevice v-show="editbombs" ref="editL" v-on:msgHides="editbombHides" :name="editname" :cloudId="editId" :isChange="isChange" :upo="upo" :num="num" :isHs="isHs" :language="language" v-on:refresh="refreshSet"></EditDevice>
        <ShareRemind v-show="remindSH" v-on:close="remindClose" v-on:reRemind="receiveOnceSet" ref="remind" v-on:refresh="refreshSet"></ShareRemind>
        <div id="cloudObj" style="width:0;height:0;overflow:hidden;"></div>
        <loading v-show="loadings"></loading>
        <Dialog :lan="lanNow.lan" v-show="false"></Dialog>
    </div>
</template>
<script>
import loading from './Loading'
import MyDevice from './MyDevice'
import ShareDevice from './ShareDevice'
import ShareRecords from './ShareRecords'
import UserMes from './UserMes'
import AddDevice from './AddDevice'
import AddDeviceHs from './AddDeviceHs'
import ShareToFriend from './ShareToFriend'
import ShareToFriends from './ShareToFriends'
import EditDevice from './EditDevice'
import ShareRemind from './ShareRemind'
import cloud from '../assets/js/cloud'
import loginMes from '../assets/js/login'
import Dialog from './Dialog'
export default {
    name:'Cloud',
    components:{
        MyDevice:MyDevice,
        ShareDevice:ShareDevice,
        ShareRecords:ShareRecords,
        UserMes:UserMes,
        AddDevice:AddDevice,
        AddDeviceHs:AddDeviceHs,
        ShareToFriend:ShareToFriend,
        ShareToFriends:ShareToFriends,
        ShareRemind:ShareRemind,
        EditDevice:EditDevice,
        loading:loading,
        Dialog:Dialog
    },
    data(){
        return {
            userName:'',
            bomb:false,
            bombs:false,
            editbombs:false,
            hsLogin:false,
            deviceManagerText:'',
            addDeviceText:'',
            addAll:'',
            refresh:'',
            userImg:'./static/img/admin.png',
            logoutImg:'./static/img/logout.png',
            logoutText:'',
            language:'',
            myDevice:[],
            myDevices:[],
            cid:[],
            shareDevice:[],
            shareDevices:[],
            editname:'',
            editId:'',
            webs:'',
            sharebom:false,
            shareSet:false,
            copy:'',
            ocx:'',
            isLogout:false,
            searchList:'',
            searchOk:true,
            isNg:false,
            isChange:false,
            upo:'',
            num:1,
            isHs:0,
            loadings:false,
            hsID:[],
            HsOnce:true,
            receiveOnce:true,
            receive:[],
            remindSH:false,
            deviceR:{},
            timeCount:'',
            timeCountHs:'',
            loginCount:'',
            loginNum:0,
            repeatSet:'',
            vpText:'',
            vpTextUrl:'',
            vpDownUrl:'',
            vPIn:false,
            isHSLogin:true
        }
    },
    beforeCreate:function(){
        var lan=localStorage.getItem('lan');
        var lang=this.getLan(this.listFile,lan)[lan];
        this.lanNow.lan=lang;
        this.ajaxH.session=this.$route.params.sessionId||localStorage.getItem('sessionId');
        this.ajaxH.user=this.$route.params.user||unescape(localStorage.getItem("user"));
        this.hsState.$this=this;
    },
    mounted:function(){
        this.userName=this.ajaxH.user;
        this.isHSLogin=this.baseData.isHSLogin;
        this.lang();
        var css=this.getCss('cloud');
        $('head').append('<style>'+css+'</style>');
        this.getMyDeviceList();
        this.addObj();
        if(this.browserDetect() !== 'IE'){
            this.websocketSet();
        }else if(this.browserDetect() == 'IE'){
            setTimeout(function(){
                try {
                    var test=this.ocx.IGetSupportP2P()-0;
                } catch (error) {
                    if(this.$router.currentRoute.name==='Cloud'){
                        this.vPIn=false;
                        if(confirm(this.lanNow.lan['K149_plugIn'])){
                            window.open(this.baseData['Plug-in']);
                        };
                    };
                };
            }.bind(this), 3000);
        };;
        document.onkeyup='';
        setTimeout(function(){
            this.getMyDeviceList();//第一次查询会查不到在线状态，初始化查询两次
            setTimeout(function(){
                this.getMyDeviceList();//第一次查询会查不到在线状态，初始化查询两次
            }.bind(this),3000);
        }.bind(this),3000);
    },
    methods:{
        websocketSet:function(){
            var t=setInterval(function(){
                if(this.baseData.vSNt===-1||this.baseData.vSNt>=5){
                    clearTimeout(t);
                    this.socketObj.set={};
                    this.socket.set = new WebSocket("ws://127.0.0.1:" + this.baseData.vSPort);
                    this.socket.set.onmessage = function(ev){
                        var msg = eval('(' + ev.data.replace(/[\r\n]/g,"").replace('version="1.0"','version=\\"1.0\\"').replace('encoding="UTF-8"','encoding=\\"UTF-8\\"') + ')');
                        var cm = Number(msg.cmd);
                        var res = msg.param;
                        var f=this.socketObj.set[cm];
                        if(typeof this.socketObj.set[cm]==='function'){
                            f(res);
                        };
                    }.bind(this);
                    this.socket.set.onopen = function() {
                        this.socket.wsS = false;
                    }.bind(this);
                    this.socket.set.onclose = function() {
                        if (this.socket.wsS) {
                            this.socket.wsS = false;
                            this.socket.wsT = true;
                            this.vPIn=false;
                            alert(this.lanNow.lan['K164_Connection']);
                        } else {
                            setTimeout(function() {
                                alert(this.lanNow.lan['K165_Disconnect']);
                            }.bind(this), 3000);
                        }
                    }.bind(this);
                };
            }.bind(this),1000);
        },
        refreshSet:function(){
            if(this.repeatSet===''){
                this.clear();
                this.repeatSet=setTimeout(function(){
                    setTimeout(function(){
                        this.loginNum=0;
                        this.getMyDeviceList();
                    }.bind(this),500);
                }.bind(this),500);
            }else{
                clearTimeout(this.repeatSet);
                this.clear();
                this.repeatSet=setTimeout(function(){
                    setTimeout(function(){
                        this.loginNum=0;
                        this.getMyDeviceList();
                    }.bind(this),500);
                }.bind(this),500);
            };
        },
        loginR:function(){
            var xml=loginMes.login({
                oem:this.baseData.oem,
                userName:this.userName,
                userPwd:this.hashEncryption(unescape(localStorage.getItem("pwd")))
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                async:true,
                type:'auth/user',
                xml:xml,
                method:this.loginRu
            });
            
        },
        loginRu:function(data){
            var result = $(data).find('header').find('result').text();
            if(result === "0"){
                var sessionId=$(data).find('session').find('id').text();
                localStorage.setItem('sessionId',sessionId);
                this.ajaxH.session=sessionId;
                this.loginNum=0;
                this.ajaxH.repeat();
                this.ajaxH.repeat=function(){};
                this.getMyDeviceList();
            }else if(result === "100101000"){
                this.setPosID($(data).find('redirect-region-id').text());
                this.loginR();
                return false;
            }else{
                if(this.loginNum===3){
                    clearTimeout(this.loginCount);
                    this.loginNum=0;
                    alert(this.lanNow.lan['K165_Disconnect']);
                    return false;
                };
                this.loginNum++;
                this.loginCount=setTimeout(function(){
                    this.loginR();
                }.bind(this),2000);
            };
        },
        getMyDeviceList:function(){
            this.getDevice();
        },
        getDevice:function(){
            var list=cloud.getList({
                sessionId:this.ajaxH.session,
                oem:this.baseData.oem
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                async:true,
                type:'auth/user',
                xml:list,
                method:this.getDeviceR
            });
        },
        getDeviceR:function(data){
            if(data===''||data===undefined){
                return false;
            };
            var result=$(data).find('result').text();
            if(result==='0'){
                this.myDevices=[];
                this.cid=[];
                this.receive=[];
                var dev=[];
                var device=$(data).find('device');
                var $this=this;
                device.each(function(){
                    var shareAccess = $(this).find('share-access');
                    var enable = shareAccess.find('enable').text();
                    var switch1 = shareAccess.find('switch').text();
                    var hsDevice = $(this).find('is-hs-device').text();
                    if (hsDevice === '3' && (enable !== '1' || switch1 !== '1')) {
                        return
                    }
                    var obj=$.extend(true,{},cloud.listObj);
                    var id=$(this).children('id').text();
                    obj.id=id;
                    obj.type=$(this).children('model').text();
                    obj.name=$(this).children('name').text();
                    obj.share=true;
                    obj.shareStatus=false;
                    var fs=$(this).children('from-share').text()-0;
                    obj.isShare=fs;
                    obj.user=fs?$(this).children('memo-name').text():'';
                    var week=$(this).children('weekdays');
                    obj.weekdays=week.length?week.children('weekdays').text():0;
                    var ad=$(this).children('account-id');
                    obj.accountID=ad.length?ad.text():0;
                    obj.change=true;
                    obj.access=true;
                    obj.del=true;
                    var ishs=$(this).children('is-hs-device');
                    obj.isHs=ishs.length?ishs.text()-0:0;
                    var num=$(this).children('channel-num');
                    obj.channel=num.length?num.text()-0:1;
                    obj.shareNum=1;
                    var state=$(this).children('share-state');
                    obj.shareState=state.length?state.text()-0:0;
                    obj.password=$(this).children('dynamic-password').text();
                    obj.encodeKey=$(this).children('data-encode-key').text();
                    if(state.length&&(obj.shareState===0)){
                        if(fs){
                            $this.receive.push({
                                id:id,
                                user:obj.user,
                                name:obj.name,
                                accountID:obj.accountID,
                                isHs:obj.isHs
                            });
                        };
                    };
                    if(obj.isShare){
                        if(id!==''){
                            obj.share=false;
                            obj.shareStatus=true;
                        };
                        if(obj.shareState!==1){
                            obj.change=false;
                            obj.access=false;
                        };
                    };
                    $this.cid.push({
                        id: id,
                        isHs: obj.isHs
                    });
                    dev.push(obj)
                });
                this.myDevices=dev;
                if(this.receive.length){
                    this.$refs.remind.getMes(this.receive);
                    this.remindSH=true;
                };
                this.ajaxH.repeat();
                this.ajaxH.repeat=function(){};
            }else if(result==='100100001'||result===''){
                if(this.loginNum===0){
                    this.clear();
                    this.loginR();
                    return false;
                };
            }else{
                var key = this.promptInfo(result);
                alert(this.lanNow.lan[key] == undefined ? key : this.lanNow.lan[key]);
            };
            this.getSD();
            this.getState();
            this.getStateHs();
        },
        getState:function(){
            var arr=[];
            this.myDevices.forEach(function (item) {
                if (!item.isHs || item.isHs === 3) {
                    arr.push(item.id);
                }
            })
            if(arr.length===0){
                // this.timeCount=setTimeout(function(){
                //     clearTimeout(this.timeCount);
                //     this.getState();
                // }.bind(this),2000);
                return false;
            };
            if(this.browserDetect() !== 'IE'){
                this.socketObj.set[148]=function(data){
                    console.log('state-sucess:' + JSON.stringify(data));
                    this.hsState.state = data[0];
                    for (var key in this.hsState.state) {
                        this.myDevices.forEach(function (item, index) {
                            if (item.id === key && (!item.isHs || item.isHs === 3)) {
                                this.myDevices[index].online = this.hsState.state[key] - 0 ? true : false;
                            }
                        }.bind(this))
                    };
                }.bind(this);
                this.socketObj.set[7]=function(data){
                    var sup=data[0].split(',');
                    if(sup[1]-0){
                        this.socket.set.send(this.jsonStr(148,[arr.join(',')]));//非IE浏览器端口穿透
                    }else{
                        console.log('sup:'+sup[1]);
                        var devStateStr=cloud.getDevStateList({
                            sessionId:this.ajaxH.session,
                            oem:this.baseData.oem,
                            list:arr.join(',')
                        });
                        var data=this.ajaxSet({
                            ip:this.cloudName,
                            type:'p2pust/user',
                            xml:devStateStr,
                            async:true,
                            method:this.getStateR
                        });
                    };
                }.bind(this);
                if(this.socket.set.readyState===1){
                    console.log('state-send:' + arr.join(','));
                    this.socket.set.send(this.jsonStr(7,['none']));//查询自研云状态
                }else{
                    
                };
            }else{
                var sup=this.ocx.IQueryNewVerInfo(30);
                if(sup-0){
                    try {
                        if(this.HsOnce){
                            this.HsOnce=false;
                            this.ocx.IInitCloud();
                        };
                        console.log('state-send:' + arr.join(','));
                        this.ocx.IGetCloudIDStatusEx('{'+arr.join(',')+'}');
                        console.log('接口调用成功');
                    } catch (error) {
                        
                    };
                }else{
                    console.log('sup:'+sup);
                    var devStateStr=cloud.getDevStateList({
                        sessionId:this.ajaxH.session,
                        oem:this.baseData.oem,
                        list:arr.join(',')
                    });
                    var data=this.ajaxSet({
                        ip:this.cloudName,
                        type:'p2pust/user',
                        xml:devStateStr,
                        async:true,
                        method:this.getStateR
                    });
                };
            };
            // var devStateStr=cloud.getDevStateList({
            //     sessionId:this.ajaxH.session,
            //     oem:this.baseData.oem,
            //     list:arr.join(',')
            // });
            // var data=this.ajaxSet({
            //     ip:this.cloudName,
            //     type:'p2pust/user',
            //     xml:devStateStr,
            //     async:true,
            //     method:this.getStateR
            // });
        },
        getStateR:function(list){
            if(list===''||list===undefined){
                return false;
            };
            var result=$(list).find('result').text();
            if(result==='0'){
                var listArr=[];
                var listVal=$(list).find('value');
                var $this=this;
                listVal.each(function(index){
                    var lId=$(this).find('devid').text();
                    var lIp=$(this).find('pub-ip').length?$(this).find('pub-ip').text():'';
                    var lOnline=$(this).find('state').text()==='online'?true:false;
                    $this.myDevices.forEach(function (item, index) {
                        if (item.id === lId && (!item.isHs || item.isHs === 3)) {
                            $this.myDevices[index].ip=lIp;
                            $this.myDevices[index].online=lOnline;
                        }
                    });
                });
            }else if(result==='100100001'||result===''){
                if(this.loginNum===0){
                    this.clear();
                    this.loginR();
                    return false;
                };
            }else{
                var key = this.promptInfo(result);
                alert(this.lanNow.lan[key] == undefined ? key : this.lanNow.lan[key]);
            };
            // this.timeCount=setTimeout(function(){
            //     clearTimeout(this.timeCount);
            //     this.getState();
            // }.bind(this),2000);
        },
        clear:function(){
            // clearTimeout(this.timeCount);
            // clearTimeout(this.timeCountHs);
        },
        getStateHs:function(){
            var arr=[];
            this.myDevices.forEach(function (item) {
                if(item.isHs && item.isHs !== 3){
                    arr.push(item.id);
                };
            })
            if(arr.length===0){
                // this.timeCount=setTimeout(function(){
                //     clearTimeout(this.timeCount);
                //     this.getState();
                // }.bind(this),2000);
                return false;
            };
            if(this.browserDetect() !== 'IE'){
                this.socketObj.set[124]=function(data){
                    console.log('state-sucess:' + JSON.stringify(data));
                    this.hsState.state = data[0];
                    for (var key in this.hsState.state) {
                        this.myDevices.forEach(function (item, index) {
                            if (item.id === key && item.isHs && item.isHs !== 3) {
                                this.myDevices[index].online = this.hsState.state[key] - 0 ? true : false;
                            }
                        }.bind(this))
                    };
                    // this.timeCountHs = setTimeout(function() {
                    //     clearTimeout(this.timeCountHs);
                    //     this.getStateHs();
                    // }.bind(this), 2000);
                }.bind(this);
                if(this.socket.set.readyState===1){
                    console.log('state-send:' + arr.join(','));
                    this.socket.set.send(this.jsonStr(124,[arr.join(',')]));//非IE浏览器端口穿透
                }else{
                    
                };
            }else{
                try {
                    if(this.HsOnce){
                        this.HsOnce=false;
                        this.ocx.IInitCloud();
                    };
                    console.log('state-send:' + arr.join(','));
                    this.ocx.IGetCloudIDStatus('{'+arr.join(',')+'}');
                    console.log('接口调用成功');
                } catch (error) {
                    
                };
            };
        },
        receiveOnceSet:function(sh){
            this.receiveOnce=sh;
        },
        remindSHSet:function(sh){
            this.remindSH=sh;
        },
        remindGet:function(data){
            this.$refs.remind.getMes(data);
        },
        getSD:function(){
            var str=cloud.deviceAllShare({
                sessionId:this.ajaxH.session,
                oem:this.baseData.oem,
            });
            this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:str,
                async:true,
                method:this.getSDR
            });
        },
        getSDR:function(data){
            if(data===''||data===undefined){
                return false;
            };
            var result=$(data).find('result').text();
            if(result==='0'){
                var device=$(data).find('device');
                var arr=[];
                for(var i=0;i<device.length;i++){
                    var id=device.eq(i).find('device-id').text();
                    var isInID = false;
                    var thisObj;
                    this.myDevices.forEach(function (item) {
                        if (!isInID && item.id === id) {
                            isInID = true;
                            thisObj = item
                        }
                    })
                    if(!isInID){
                        continue;
                    };
                    var mes=thisObj;
                    var ip=mes.ip;
                    var name=mes.name;
                    var online=mes.online;
                    var pwd=mes.password;
                    var encodeKey=mes.encodeKey;
                    var channel=mes.channel;
                    var isHs=mes.isHs;
                    var friend=device.eq(i).find('friend');
                    for(var j=0;j<friend.length;j++){
                        var obj={
                            deviceId:id,
                            cloudId:id,
                            ip:ip,
                            online:online,
                            name:name,
                            account:friend.eq(j).find('account').text(),
                            accountId:friend.eq(j).find('account-id').text(),
                            change:true,
                            access:true,
                            pwd:pwd,
                            encodeKey:encodeKey,
                            channel:channel,
                            isHs:isHs,
                            nikeName:friend.eq(j).find('memo-name').text(),
                            powers:friend.eq(j).find('powers').text(),
                            power:function(){
                                var powers=friend.eq(j).find('powers').text().split(',');
                                var text=[];
                                if(powers.indexOf('1')>-1){
                                    text.push(this.language['K136_Preview']);
                                };
                                if(powers.indexOf('3')>-1){
                                    text.push(this.language['K137_Playback']);
                                };
                                if(powers.indexOf('4')>-1){
                                    text.push(this.language['K138_Alarm']);
                                };
                                return text.join(',');
                            }.bind(this)(),
                            periods:friend.eq(j).find('periods').text(),
                            weekdays:friend.eq(j).find('weekdays').text(),
                            time:function(){
                                var p=friend.eq(j).find('periods').text();
                                var w=friend.eq(j).find('weekdays').text();
                                var wArr=w.split(',');
                                var wl=wArr.length;
                                var wRArr=[];
                                for(var i=0;i<wl;i++){
                                    if(wArr[i]-0===0){
                                        wRArr.push(this.language['K128_Sun']);
                                    }else if(wArr[i]-0===1){
                                        wRArr.push(this.language['K129_Mon']);
                                    }else if(wArr[i]-0===2){
                                        wRArr.push(this.language['K130_Tue']);
                                    }else if(wArr[i]-0===3){
                                        wRArr.push(this.language['K131_Wed']);
                                    }else if(wArr[i]-0===4){
                                        wRArr.push(this.language['K132_Thu']);
                                    }else if(wArr[i]-0===5){
                                        wRArr.push(this.language['K133_Fri']);
                                    }else if(wArr[i]-0===6){
                                        wRArr.push(this.language['K134_Sat']);
                                    };
                                };
                                var wR=wRArr.length?'('+wRArr.join(',')+')':'';
                                return p+wR;
                            }.bind(this)(),
                            status:friend.eq(j).find('share-state').text()-0,
                            // shareMode:friend.eq(j).find('share-mode').length?friend.eq(j).find('share-mode').text():'',
                            shareMode:'',
                            shareSub:friend.eq(j).find('share-subs').length?friend.eq(j).find('share-subs'):'',
                        };
                        arr.push(obj);
                    };
                };
                this.shareDevices=arr;
            }else if(result==='100100001'||result===''){
                if(this.loginNum===0){
                    this.clear();
                    this.loginR();
                    return false;
                };
            }else{
                var key = this.promptInfo(result);
                alert(this.lanNow.lan[key] == undefined ? key : this.lanNow.lan[key]);
            };
        },
        logout:function(){
            this.isLogout=true;
            clearTimeout(this.searchList);
            var logoutStr=cloud.logout({
                sessionId:this.ajaxH.session,
                oem:this.baseData.oem
            });
            this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:logoutStr
            });
            this.logoutResult();
        },
        logoutResult:function(){
            // localStorage.setItem('record',false);
            if(!localStorage.getItem('checkbox')){
                localStorage.setItem('user',unescape(this.userName));
                localStorage.setItem('pwd',unescape(this.userPwd));
            };
            this.$router.push('./');
            window.location.reload(true);
        },
        bombShow:function(){
            this.$refs.userL.lang();
            this.bomb=true;
        },
        bombHide:function(data){
            this.bomb=data;
        },
        bombShows:function(){
            this.$refs.addL.lang();
            this.bombs=true;
        },
        bombHides:function(data){
            this.bombs=data.hide;
            //   if(data.suc){
            //     this.getMyDeviceList();
            //   };
        },
        hsLoginShow:function(){
            this.hsLogin=true;
        },
        hsLoginHide:function(){
            this.hsLogin=false;
        },
        addGetList:function(){
            this.$refs.addL.exist(this.myDevice);
        },
        addIm:function(){
            this.$refs.addI.exist(this.myDevice);
        },
        shareBoms:function(data){
            this.shareSet=true;
            this.$refs.shareSet.init(data);
        },
        sharePower:function(data){
            this.$nextTick(function(){
                this.$refs.share.getID(data);
                this.$refs.share.lang();
                if(data.isHs){
                    this.$refs.share.confirm();
                }else{
                    this.sharebom=true;
                };
            });
        },
        editbombHides:function(data){
            this.editbombs=data.hide;
            // if(data.suc){
            //     this.getMyDeviceList();
            // };
        },
        editBoms:function(data){
            this.editId=data.id;
            this.editname=data.name;
            this.isChange=data.isChange;
            this.upo=data.upo;
            this.num=data.num;
            this.isHs=data.isHs;
            var _that=this;
            this.$nextTick(function(){
                this.$refs.editL.lang();
                this.editbombs=true;
            });
        
        },
        loadMsg:function(sh){
            this.loadings=sh;
        },
        shareClose:function(data){
            this.sharebom=false;
        },
        shareClosed:function(data){
            this.shareSet=false;
        },
        remindClose:function(){
            this.remindSH=false;
        },
        lang:function(){
            this.language=this.lanNow.lan;
            this.deviceManagerText=this.language['K021_DeviceManage'];
            this.addDeviceText=this.language['K022_AddDevice'];
            this.addAll=this.language['K170_Import'];
            this.refresh=this.language['K199_Refresh'];
            this.logoutText=this.language['K028_Logout'];
            this.vpText=this.language['K222_InstallVL']+' ';
            this.vpTextUrl=this.language['K223_InstallVLC'];
            this.vpDownUrl=this.baseData['Plug-in'];
        },
        addObj:function(){
            var system=this.detectOS();
            if (system === "win") {
                var obj="<object name='ocx' id='ocx' width='0' height='0' classid='CLSID:E0DA039D-992F-4187-A105-C699A71F5F06'></object>";
                $('#cloudObj').append(obj);
            } else if (system === "Mac") {
                var obj="<embed width='0' height='0' type='text/x-vplugin' name='ocx' id='ocx'>";
                $('#cloudObj').append(obj);
            };
            this.ocx=$('#ocx')[0];
        },
        changeShare:function(){
            var obj=this.myDevices;
            var num=10;
            var share=[];
            this.shareDevices.forEach(function(el,idx){
                var thisObj;
                obj.forEach(function (item) {
                    if (item.id === el.deviceId) {
                        thisObj = item;
                    }
                })
                el.online=thisObj.online;
                el.ip=thisObj.ip;
                if(share.length){
                    if(share[share.length-1].length<num){
                        share[share.length-1].push(el);
                    }else{
                        share.push([el]);
                    };
                }else{
                    share.push([el]);
                };
            });
            if(share.length){
                this.shareList.list=share[0];
            };
            if(share.length){
                var adds=num-share[share.length-1].length;
                if(share.length&&share[share.length-1].length<num){
                    for(var i=0;i<adds;i++){
                        share[share.length-1].push({
                            deviceId:'',
                            cloudId:'',
                            ip:'',
                            name:'',
                            nikeName:'',
                            account:'',
                            change:false,
                            access:false,
                            pwd:'',
                            time:''
                        });
                    };
                };
            }else{
                var init=[];
                for(var i=0;i<10;i++){
                    init.push({
                        deviceId:'',
                        cloudId:'',
                        ip:'',
                        name:'',
                        nikeName:'',
                        account:'',
                        change:false,
                        access:false,
                        pwd:'',
                        time:''
                    });
                };
                share.push(init);
            };
            this.shareDevice=share;
        }
    },
    watch:{
        myDevices:{
            handler(newName, oldName) {
                var obj=this.myDevices;
                var arr=[];
                var num=10;
                this.cid.forEach(function(el,i){
                    var thisObj;
                    obj.forEach(function (item) {
                        if (item.id === el.id && item.isHs === el.isHs) {
                            thisObj = item;
                        }
                    })
                    if(arr.length){
                        if(arr[arr.length-1].length<num){
                            arr[arr.length-1].push(thisObj);
                        }else{
                            arr.push([thisObj]);
                        };
                    }else{
                        arr.push([thisObj]);
                    };
                });
                var add=arr.length?num-arr[arr.length-1].length:num;
                var index=arr.length?arr.length-1:0;
                arr.length===0&&arr.push([]);
                for(var i=0;i<add;i++){
                    arr[index].push($.extend({},cloud.listObj));
                };
                this.myDevice=arr;
                if(this.shareDevices.length){
                    this.changeShare();
                };
            },
            immediate: false,
            deep: true
        },
        shareDevices:{
            handler(newName, oldName) {
                this.changeShare();
            },
            immediate: false,
            deep: true
        }
    }
}
</script>
<style>
    #cloud{
        width:100%;
        min-width:1440px;
        height:100%;
        min-height:800px;
    }
    #cloudNav{
        width:100%;
        height: 40px;
        background-color:#364860;
    }
    #cloudManage{
        max-width: 220px;
        padding:0 10px;
        height:100%;
        font-size:14px;
        font-weight: bold;
        margin-left:60px;
        line-height:40px;
        background-color: #2A3950;
        color:#fff;
        box-sizing: border-box;
        cursor: pointer;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    #cloudAdd,#addAll,#refresh{
        padding:0 10px;
        max-width: 120px;
        height:30px;
        font-size:14px;
        font-weight: bold;
        margin-left:30px;
        margin-top:5px;
        background-color: #1F9DF1;
        color:#fff;
        box-sizing: border-box;
        border: none;
        outline: none;
        cursor: pointer;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    #userLogout,#ulUser,#ulLogout{
        height:100%;
    }
    #userLogout{
        margin-right:20px;
    }
    #ulUser img,#ulLogout img{
        margin-top: 9px;
    }
    #ulUser span,#ulLogout span{
        max-width: 180px;
        color:#fff;
        font-size:14px;
        line-height: 40px;
        padding:0 10px;
        cursor: pointer;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    #cloudContent{
        width:100%;
        height:calc(100% - 40px);
        background-color: #D4DBE5;
        padding:0 60px;
        box-sizing: border-box;
        overflow: hidden;
    }
    .listTop{
        margin-top:20px;
    }
    .downVp{
        font-size: 14px;
        margin-top:20px;
    }
    .downVp span{
        color:red;
    }
    .downVp a{
        color:#1b773d;
    }
</style>
<style scoped>
    @import '../assets/css/cloud.css';  
</style>




// WEBPACK FOOTER //
// src/components/Cloud.vue